var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"md:py-8 lg:py-8 py-2"},[_c('p',{staticClass:"text-black font-semibold lg:text-2xl md:text-2xl text-2xl w-full"},[_vm._v("\n      About Me\n    ")]),_c('div',{staticClass:"mt-2"},[_c('p',{staticClass:"font-normal text-md cust-fontstyle",domProps:{"innerHTML":_vm._s(_vm.userDetails.aboutMe)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }